import api from "./api";

async function getMerchant(id) {
  try {
    const response = await api.get(
      `api/merchants/${id}`
    );
    return response.data;
  } catch (error) {
    return null;
  }
}

async function getMerchantByOrganisationId(id) {
  try {
    const response = await api.get(
      `api/merchants/byorganisationId/${id}`
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getMerchant,
  getMerchantByOrganisationId,
};
